import React from 'react';
import { DollarSign, TrendingUp, CheckCircle } from 'lucide-react';

export function EarningsSection({ earnings }) {
  if (!earnings) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8" data-testid="earnings-summary">
      <div className="card-theraflow p-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-[#6B8E7C]/10 flex items-center justify-center">
            <DollarSign className="w-5 h-5 text-[#6B8E7C]" strokeWidth={1.5} />
          </div>
          <p className="text-sm text-[#63635E]">Saldo Disponível</p>
        </div>
        <p className="text-2xl font-light text-[#292927]">
          R$ {(earnings.current_balance || 0).toFixed(2)}
        </p>
      </div>
      <div className="card-theraflow p-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-[#4A5D4E]/10 flex items-center justify-center">
            <TrendingUp className="w-5 h-5 text-[#4A5D4E]" strokeWidth={1.5} />
          </div>
          <p className="text-sm text-[#63635E]">Total Ganhos</p>
        </div>
        <p className="text-2xl font-light text-[#292927]">
          R$ {(earnings.total_earnings || 0).toFixed(2)}
        </p>
      </div>
      <div className="card-theraflow p-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-[#D4A373]/10 flex items-center justify-center">
            <CheckCircle className="w-5 h-5 text-[#D4A373]" strokeWidth={1.5} />
          </div>
          <p className="text-sm text-[#63635E]">Sessões Completas</p>
        </div>
        <p className="text-2xl font-light text-[#292927]">
          {earnings.completed_sessions_count || 0}
        </p>
      </div>
    </div>
  );
}
